import {connect} from 'react-redux'
import {ActionsRow, commons, FixedDropDownButton, Icon, Loader, modal, utils} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as polozkaActions from "../../actions/polozkaActions";
import {getIdFromProps} from "../../utils/utils";
import TablePanel from "../../components/TablePanel";
import PolozkaApi from "../../api/gen/cgo/PolozkaApi";
import CenikPolozkaForm from "../../forms/CenikPolozkaForm";
import * as React from "react";
import {Component} from "react";
import {withTranslation, WithTranslation} from "react-i18next";

const {sinkEvent} = commons;

/**
 * Stránka administrace - seznam položek konkrétního ceníku
 */
class CenikPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(polozkaActions.fetchCenikPolozkyIfNeeded(getIdFromProps(this.props, "idCenik")));
        this.props.dispatch(polozkaActions.fetchCenikyIfNeeded());
    };

    handleCreateCenikPolozka = () => {
        const {t} = this.props;
        const cenikId = getIdFromProps(this.props, "idCenik");
        this.props.dispatch(modal.ModalActions.show(
            CenikPolozkaForm,
            {
                onSubmit: (data) => {
                    return PolozkaApi.createCenikPolozka(cenikId, data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(polozkaActions.invalidateCenikPolozky());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('new_item_price_list'),
            {size: "sm"}
        ));
    };

    handleEditCenikPolozka = (cenikPolozka) => {
        const {t} = this.props;
        const cenikId = getIdFromProps(this.props, "idCenik");
        this.props.dispatch(modal.ModalActions.show(
            CenikPolozkaForm,
            {
                onSubmit: (data) => {
                    return PolozkaApi.updateCenikPolozka(cenikId, cenikPolozka.id, data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(polozkaActions.invalidateCenikPolozky());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: cenikPolozka,
            },
            t('item_price_list_change'),
            {size: "sm"}
        ));
    };

    handleDeleteCenikPolozka = (cenikPolozka) => {
        const {t} = this.props;
        const cenikId = getIdFromProps(this.props, "idCenik");
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('item_delete'),
                <span>{t('item_price_list_delete',{itemName: cenikPolozka.polozka.nazev})}</span>,
                () => {
                    PolozkaApi.deleteCenikPolozka(cenikId, cenikPolozka.id).then(() => {
                        this.props.dispatch(polozkaActions.invalidateCenikPolozky());
                    });
                },
                null,
                t('delete')
            )
        );
    };

    renderContextMenu = (cenikPolozka) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditCenikPolozka.bind(this, cenikPolozka))}>{t('edit')}</DropdownItem>
            <DropdownItem key="1" onClick={sinkEvent(this.handleDeleteCenikPolozka.bind(this, cenikPolozka))}>{t('delete')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {cenikPolozkyList, cenikyList, t} = this.props;

        if (!cenikPolozkyList.fetched || !cenikyList.fetched) {
            return <Loader/>;
        }

        let content;
        if (cenikPolozkyList.rows.length !== 0) {
            content = cenikPolozkyList.rows.map(cenikPolozka => {
                return <CardBody key={cenikPolozka.id}>
                    <ActionsRow actions={this.renderContextMenu(cenikPolozka)} onClick={this.handleEditCenikPolozka.bind(this, cenikPolozka)}>
                        <Row>
                            <Col xs={3}>{cenikPolozka.polozka.nazev}</Col>
                            <Col xs={3}>{cenikPolozka.cena}</Col>
                            <Col xs={3}>{cenikPolozka.sleva}</Col>
                        </Row>
                    </ActionsRow>
                </CardBody>;
            });
        } else {
            content = <CardBody><i>{t('no_items_price_list')}</i></CardBody>
        }

        const cenikId = getIdFromProps(this.props, "idCenik");
        const cenik = cenikyList.rows?.find((cenik) => cenik.id === cenikId)

        return <AdminPage
                title={t('admin.price_list',{priceListID: cenik?.nazevCenik ? cenik?.nazevCenik : cenikId})}
                subtitle={t('admin.price_list_detail_info',{priceListID: cenik?.nazevCenik ? cenik?.nazevCenik : cenikId})}
                content={
                    <div>
                        <ButtonToolbar>
                            <Button color="primary" onClick={this.handleCreateCenikPolozka}>{t('new_f')}</Button>
                        </ButtonToolbar>
                        <TablePanel header={
                            <Row>
                                <Col xs={3}>{t('labels.item')}</Col>
                                <Col xs={3}>{t('labels.price')}</Col>
                                <Col xs={3}>{t('discount')}</Col>
                            </Row>
                        }>
                            {content}
                        </TablePanel>
                    </div>
                }
            />
    }
}

function mapStateToProps(state) {
    return {
        cenikyList: utils.storeFromArea(state, polozkaActions.CENIKY_LIST_AREA),
        cenikPolozkyList: utils.storeFromArea(state, polozkaActions.CENIK_POLOZKY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(CenikPage));

